import React, {useEffect, useState} from "react";
import styles from './Calendar.module.css'
import {
    SchedulesData
} from "../../../queries/useSchedules";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import './Calendar-override.css'
import moment from 'moment'
import {
    useFetchEntityScheduleDropdowns
} from "../../../queries/useEntityScheduleDropdowns";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, DialogTitle,
    IconButton, Typography, withStyles
} from "@material-ui/core";
import axios from 'axios'

import {Autocomplete, Grid, Popover} from "@mui/material";
import {
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField
} from "@mui/material";
import {SchedulesForm} from "./Schedules.Form";
import {globalSchedulesFetcher} from "../../../queries/useScheduleDropdowns";
import dayjs from "dayjs";
import {QueryClient} from "react-query";
import {useForm} from "react-hook-form";
import HookForm from "../../../components/common/HookForm";
import TextInput from "../../../components/common/inputs/TextInput";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
const localizer = momentLocalizer(moment)

interface FormData {
    customernumber: string
}

const CalendarPage = (params) => {
    const formMethods = useForm<FormData>()
    const { setValue, watch, getValues } = formMethods
    const queryClient = new QueryClient()
    const [vacationDetails, setVacationDetails] = useState([]);
    const [gridShowing, setGridShowing] = useState(false)
    const [isFormShowing, setIsFormShowing] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [comment, setComment] = useState("");
    const [openVacation, setOpenVacation] = useState(false);
    const [errors, setErrors] = useState({
        startDate: "",
        endDate: "",
    });


    const handleClose = () => {
        setOpenVacation(false);
    };
    const validateDates = () => {
        const currentDate = new Date().toISOString().slice(0, 10);
        let isValid = true;
        let newErrors = {
            startDate: "",
            endDate: "",
        };

        if (startDate <= currentDate) {
          newErrors.startDate = "Start date must be in the future.";
          isValid = false;
        }

        if (endDate <= currentDate) {
          newErrors.endDate = "End date must be in the future.";
          isValid = false;
        }

        const start = Date.parse(startDate);
        const end = Date.parse(endDate);

        if (end < start) {
            newErrors.endDate = "End date must be equal to or after the start date.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const [gridParams, setGridParams] = useState({
        id: null,
        readonly: null,
        canedit: null,
        scheduleid: null,
        schedulenumber: null,
        scheduledivisionid: null,
        scheduledivision: null,
        scheduletemplateid: null,
        scheduletemplate: null,
        scheduledivisionwoid: null,
        schedulestatusid: null,
        schedulestatus: null,
        schedulestartdate: null,
        scheduleenddate: null,
        scheduleworklocation: null,
        schedulegeneralforemanid: null,
        schedulegeneralforeman: null,
        scheduleforemanid: null,
        scheduleforeman: null,
        scheduleaddeddate: null,
        scheduleactive: null,
        notestypeid: null,
        notestitle: null,
        noteslinkid: null,
        notescount: null,
        scheduledivisioncustomerinfo: null,
        scheduledivisionwocustomerworkorder: null,
        schedulelastdatedispatchsent: null,
        schedulecandispatch: null,
        schedulecalendarcolor: null,
    })
    const [reloadForm, setReloadForm] = useState<number>(0)
    const [scheduleDropdowns, setScheduleDropdowns] = React.useState({});
    const [calendarData, setCalendarData] = useState({canAdd: false, canaddschedule: false, employee: '', legendlist: [], message: '', schedulelist: [], showemergencybutton: false, showvacationbutton: false, status: '', type: ''})
    const [staffList, setStaffList] = useState([])
    const [custList, setCustList] = useState([])
    const [statusList, setStatusList] = useState([])

    const [activeStatus, setActiveStatus] = React.useState<string>( '');
    const [activeStatusId, setActiveStatusId] = React.useState<number>( 0);
    const [activeCust, setActiveCust] = React.useState<string>( '');
    const [activeCustId, setActiveCustId] = React.useState<number>( 0);
    const [selectedDate, setSelectedDate] = React.useState<Date>( new Date());
    const [showemergencybutton, setshowemergencybutton] = React.useState<boolean>(true);
    const [showvacationbutton, setShowvacationbutton] = React.useState<boolean>(false);
    const [staffSelect, setStaffSelect] = React.useState([]);
    const [staffSelectId, setStaffSelectId] = React.useState<number[]>([]);
    const [mobile, setMobile] = useState(window.innerWidth <= 500);
    const [dialogMsg, setDialogMsg] = React.useState("")
    const [dialogMessage, setDialogMessage] = React.useState("")

    const handleWindowSizeChange = () => {
        setMobile(window.innerWidth <= 500);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        getCalendarData()

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);


    const {data: entityScheduleDropdowns} = useFetchEntityScheduleDropdowns(params.entityId)
    useEffect(() => {
        var statusid = 0
        var custid = 0
        var staffid
        if (entityScheduleDropdowns?.statuslist && entityScheduleDropdowns?.statuslist?.length > 0) {
            statusid = -1
            // setActiveStatusId(entityScheduleDropdowns.statuslist[0].schedulestatusid)
            // setActiveStatus(entityScheduleDropdowns.statuslist[0].schedulestatus)
            setActiveStatusId(-1)
            setActiveStatus('All Status')
            setStatusList(entityScheduleDropdowns?.statuslist)
        }
        else {
            setActiveStatusId(null)
            setActiveStatus(null)
            setStatusList([])
        }
        if (entityScheduleDropdowns?.stafflist && entityScheduleDropdowns?.stafflist?.length > 0) {
            // staffid = [entityScheduleDropdowns?.stafflist[0].staffid]
            staffid = []
            // setStaffSelect([entityScheduleDropdowns?.stafflist[0].staffinfo])
            // setStaffSelectId([entityScheduleDropdowns?.stafflist[0].staffid])
            setStaffSelect([])
            setStaffSelectId([])
            setStaffList(entityScheduleDropdowns?.stafflist)
        }
        else {
            setStaffSelect([])
            setStaffSelectId([])
            setStaffList([])
        }
        if (entityScheduleDropdowns?.custlist && entityScheduleDropdowns?.custlist?.length > 0) {
            custid = -1
            // setActiveCustId(entityScheduleDropdowns.custlist[0].custid)
            // setActiveCust(entityScheduleDropdowns.custlist[0].custinfo)
            setActiveCustId(-1)
            setActiveCust("All Customers")
            setCustList(entityScheduleDropdowns?.custlist)
        }
        else {
            setActiveCustId(null)
            setActiveCust(null)
            setCustList([])
        }
        filterRowsToSelection(statusid, custid, staffid)
    }, [entityScheduleDropdowns])


    const [eventData, setEventData] = React.useState([]);
    const [legendList, setLegendList] = React.useState([]);
    const [eventFilteredData, setEventFilteredData] = React.useState([]);
    const getCalendarData = async () => {
        const body: any = {
            // entityid:  params.entityId,
            // GUID: params.calendarGuid,
        }

        const {data} = await axios.get('fieldsystemcalendar', body)
        var newstring = data.jsonString.replace(/ 0+(?![\. }])/g, '');
        const parsedData = JSON.parse(newstring)
        setCalendarData(parsedData)
    }

    useEffect(() => {
        console.log(calendarData)
        if(calendarData?.showemergencybutton){
            setshowemergencybutton(true)
        }
        else {
            setshowemergencybutton(false)
        }

        if(calendarData?.showvacationbutton){
            setShowvacationbutton(true)
        }
        else {
            setShowvacationbutton(false)
        }

        if (calendarData?.employee) {
            params.setTitle(calendarData?.employee)
        }

        if (calendarData?.legendlist && calendarData?.legendlist?.length > 0) {
            setLegendList(calendarData.legendlist)
        }
        if(calendarData && calendarData?.schedulelist && calendarData?.schedulelist.length > 0) {
            setEventRecord()
        }
        else {
            setEventData([])
            setEventFilteredData([])
        }
    }, [calendarData])

    const closeDialog = () => {
        setDialogMsg("")
        setDialogMessage('')
    }

    const setEventRecord = () => {

        const edata = calendarData?.schedulelist.map((schedulesData: SchedulesData, i) => {
            // if (schedulesData.schedulestartdate && schedulesData.schedulestartdate.length > 0) {
            console.log(schedulesData.schedulehover)
                return {
                    scheduleid: schedulesData.scheduleid,
                    start: moment(schedulesData.schedulestartdate).startOf('day').toDate(),
                    end: moment(schedulesData.schedulestartdate).startOf('day').toDate(),
                    schedulestatusid: schedulesData.schedulestatusid,
                    schedulestatus: schedulesData.schedulestatus,
                    schedulestaffid: schedulesData.schedulestaffid,
                    schedulestaff: schedulesData.schedulestaff,
                    schedulestartdate: schedulesData.schedulestartdate,
                    scheduleenddate: schedulesData.scheduleenddate,
                    scheduledispatchsubmitted: schedulesData.scheduledispatchsubmitted,
                    scheduledivisioncustomercodeid: schedulesData.scheduledivisioncustomercodeid,
                    scheduledivisioncustomerinfo: schedulesData.scheduledivisioncustomerinfo,
                    title: schedulesData.scheduledescription,
                    scheduledescription: schedulesData.scheduledescription,
                    schedulehover: schedulesData.schedulehover,
                    urllink: schedulesData.urllink,
                    readonly: schedulesData.readonly,
                    schedulecalendarcolor: schedulesData.schedulecalendarcolor
                }
            // }
        })
        setEventData(edata)
        setEventFilteredData(edata)
    }

    const getStatusOptions = () => {
        if (statusList && statusList.length > 0) {
            const statusL = statusList.map(options => {
                return (
                    <MenuItem key={options.schedulestatusid} value={options.schedulestatus}>
                        {options.schedulestatus}
                    </MenuItem>
                )
            })
            return [(
                <MenuItem key={'All Status'} value={'All Status'}>
                    {'All Status'}
                </MenuItem>
            ), ...statusL]
        }
    }

    const getCustOptions = () => {
        if (custList && custList.length > 0) {
            const custL = custList.map(options => {
                return (
                    <MenuItem key={options.custid} value={options.custinfo}>
                        {options.custinfo}
                    </MenuItem>
                )
            })
            return [(
                <MenuItem key={'All Customers'} value={'All Customers'}>
                    {'All Customers'}
                </MenuItem>
            ), ...custL]
        }
    }

    const handleStatusSelectionChange = (event: SelectChangeEvent) => {
        var statusid = -1
        if (event.target.value === 'All Status') {
            setActiveStatusId(statusid)
            setActiveStatus(event.target.value as string);
        }
        else {
            const status = statusList.filter((statusData) => statusData.schedulestatus === event.target.value as string)
            statusid = (status && status.length > 0 ? status[0].schedulestatusid : 0)
            setActiveStatusId(statusid)
            setActiveStatus(event.target.value as string);
        }

        filterRowsToSelection(statusid, activeCustId, staffSelectId)
    }

    const handleCustSelectionChange = (event: SelectChangeEvent) => {
        var custid = -1
        if (event.target.value === 'All Customers') {
            setActiveCustId(custid)
            setActiveCust(event.target.value as string);
        }
        else {
            const cust = custList.filter((custData) => custData.custinfo === event.target.value as string)
            custid = (cust && cust.length > 0 ? cust[0].custid : 0)
            setActiveCustId(custid)
            setActiveCust(event.target.value as string);
        }

        filterRowsToSelection(activeStatusId, custid, staffSelectId)
    }

    const handleStaffChange = (event, values) => {
        console.log(values);
        const vals = values.map(item => { return item.staffid} )
      setStaffSelect(values)
      setStaffSelectId(vals)
   
         filterRowsToSelection(activeStatusId, activeCustId, vals)
    }

    const filterRowsToSelection = (statusId: number, custId: number, staffId: number[]) => {
        const filteredData = eventData.filter((data) => (data.schedulestatusid === statusId || statusId === -1) && (data.scheduledivisioncustomercodeid === custId || custId === -1))
        if (staffId && staffId.length > 0) {
            const result = filteredData.filter(filteredFirst => {
                const result2 = filteredFirst.schedulestaffid.filter(ids1 => {
                    let arr = staffId.filter(ids2 => ids1 === ids2)
                    return !(arr.length === 0)
                })

                return result2.length > 0
            })
            setEventFilteredData(result)
        }
        else {
            setEventFilteredData(filteredData)
        }
    }

    const HandleEventClick = async (scheduleId: number) => {

        const scheduleData = calendarData?.schedulelist.filter((item) => item.scheduleid === scheduleId)[0]
        if (scheduleData.readonly) {
            window.open(scheduleData.urllink)
        }
        else {
            const scheduleDropdowns = await globalSchedulesFetcher(scheduleData?.scheduledivisionwoid)
            if (scheduleDropdowns) {
                setScheduleDropdowns(scheduleDropdowns)
            }

            setGridParams({
                id: scheduleData.scheduleid,
                readonly: scheduleData.readonly,
                canedit: scheduleData.canedit,
                scheduleid: scheduleData.scheduleid,
                schedulenumber: scheduleData.schedulenumber,
                scheduledivisionid: scheduleData.scheduledivisionid,
                scheduledivision: scheduleData.scheduledivision,
                scheduletemplateid: scheduleData.scheduletemplateid,
                scheduletemplate: scheduleData.scheduletemplate,
                scheduledivisionwoid: scheduleData.scheduledivisionwoid,
                schedulestatusid: scheduleData.schedulestatusid,
                schedulestatus: scheduleData.schedulestatus,
                schedulestartdate: scheduleData.schedulestartdate,
                scheduleenddate: scheduleData.scheduleenddate,
                scheduleworklocation: scheduleData.scheduleworklocation,
                schedulegeneralforemanid: scheduleData.schedulegeneralforemanid,
                schedulegeneralforeman: scheduleData.schedulegeneralforeman,
                scheduleforemanid: scheduleData.scheduleforemanid,
                scheduleforeman: scheduleData.scheduleforeman,
                scheduleaddeddate: scheduleData.scheduleaddeddate,
                scheduleactive: scheduleData.scheduleactive,
                notestypeid: scheduleData.notestypeid,
                notestitle: scheduleData.notestitle,
                noteslinkid: scheduleData.noteslinkid,
                notescount: scheduleData.notescount,
                scheduledivisioncustomerinfo: scheduleData.scheduledivisioncustomerinfo,
                scheduledivisionwocustomerworkorder: scheduleData.scheduledivisionwocustomerworkorder,
                schedulelastdatedispatchsent: scheduleData.schedulelastdatedispatchsent,
                schedulecandispatch: scheduleData.schedulecandispatch,
                schedulecalendarcolor: scheduleData.schedulecalendarcolor
            })
            setReloadForm(reloadForm + 1)
            setIsFormShowing(true)
        }
    }

    const getCalendarBackgroundColor = (event) => {
        console.log(event)
        if (
            event.schedulestatus.includes('Complete') || event.schedulestatus === 'Canceled'
        )
        {
            return '#808080'
        }
        else if (event.schedulestatus === 'Unscheduled') {
            return 'red'
        }
        else if (
            event.schedulestatus === 'Scheduled' &&
            event.scheduledispatchsubmitted === false &&
            dayjs(event.schedulestartdate).isBefore(dayjs(), 'day')
        )
        {
            return 'yellow'
        }
        else if (
            event.schedulestatus === 'Scheduled' &&
            event.scheduledispatchsubmitted === true &&
            dayjs(event.schedulestartdate).isBefore(dayjs(), 'day')
        )
        {
            return '#fed8b1'
        }
        else if (event.schedulestatus === 'Scheduled' && (dayjs(event.schedulestartdate).isAfter(dayjs(), 'day') || dayjs(event.schedulestartdate).isSame(dayjs(), 'day'))) {
            return 'green'
        }
        else if (event.schedulestatus === 'Scheduled' && event.schedulestaffid?.length === 0 && (dayjs(event.schedulestartdate).isAfter(dayjs(), 'day') || dayjs(event.schedulestartdate).isSame(dayjs(), 'day'))) {
            // Lite Green
            return '#cefad0'
        }
    }

    const eventStyleGetter = (event, start, end, isSelected) => {
        var style = {
            background: event.schedulecalendarcolor,
            color: 'black',
            fontWeight: 'bold',
            fontSize: '12px'
        }
        return {
            style: style
        }
    }

    const handleReset = () => {
        setActiveStatusId(-1)
        setActiveStatus('All Status')
        setActiveCustId(-1)
        setActiveCust("All Customers")
        setStaffSelect([])
        setStaffSelectId([])
        filterRowsToSelection(-1, -1, [])
    }

    const sendEmergency = () =>{
        axios.post('/emergency', { guid: params.calendarGuid})
        closeDialog()
    }

    const showEmergencyDlg = () =>{
        setDialogMsg('Warning - this will create a brand new job in the system. Do you really want to do this?')
    }

    const showVacationDlg = () =>{
        setOpenVacation(true)
    }
    
    const buildLegend = () => {
        const emergencyButtonData = (
            <Grid item>
                <div>
                    {showemergencybutton &&
                        <button onClick={showEmergencyDlg} style={{marginBottom: '10px'}}>Emergency/Additional Job</button>
                    }
                    {showvacationbutton &&
                        <button onClick={showVacationDlg} style={{marginLeft: '10px', marginBottom: '10px'}}>Add Vacation</button>
                    }
                </div>
            </Grid>
        )

        var finalData = (
            <></>
        )

        const legendData = legendList?.map((legend) => {
            return (
                <Grid item>
                    <div style={{backgroundColor: legend.color, color: 'black', fontSize: '12px'}}>
                        <Typography
                            variant="body2"
                            align="center"
                            component="div">
                            {legend.description}
                        </Typography>
                    </div>
                </Grid>
            )
        })

        finalData = (
            <>
                <Grid container direction="row"
                      alignItems="center"
                      justifyContent="center" columnSpacing={{ xs: .5, sm: .5, md: .5 }}>
                    {emergencyButtonData}
                </Grid>
                {params?.showLegend &&
                    <Grid container direction="row"
                          alignItems="center"
                          justifyContent="center" columnSpacing={{ xs: .5, sm: .5, md: .5 }}>
                        {legendData}
                    </Grid>
                }
            </>
        )


        return finalData
    }

    const addEmployeeVacation = async (startDate, endDate, comment) => {
        const response = await axios.put("/vacationemployeecalendar", {
            guid: params.calendarGuid,
            startdate: startDate,
            enddate: endDate,
            comment : comment
        });
        const parsedResponse = JSON.parse(response?.data.jsonString)
        if (parsedResponse.status === "success") {
            getCalendarData()
        } if (parsedResponse.status === "info") {
            setDialogMessage(parsedResponse?.message)
        }
    };

    const handleAddVacation = (startDate, endDate, comment) => {
        // Add the new vacation to the UI
        setVacationDetails([
            ...vacationDetails,
            {
                RowNumber: vacationDetails.length + 1,
                vacationid: "",
                vacationstartdate: startDate,
                vacationenddate: endDate,
                vacationcomment: comment,
            },
        ]);
        // Call the API to add the new vacation to the database
        addEmployeeVacation(startDate, endDate, comment);
    };

    const handleAdd = () => {
        if (validateDates()) {
            handleAddVacation(startDate, endDate, comment);
            handleClose();
        }
    }

    function Event(event) {
        const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
        const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const handlePopoverClose = () => {
            setAnchorEl(null);
        }
        const open = Boolean(anchorEl)

        return (
            <div>
                <span aria-owns={open ? 'mouse-over-popover' : undefined}
                  aria-haspopup="true"
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                >{event.title}</span>
                    <Popover
                        id="mouse-over-popover"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography ><div dangerouslySetInnerHTML={{__html:event.event.schedulehover}} /></Typography>
                    </Popover>
            </div>
        );
    }

    const getCustomerOptions = () => {
        // return vehicleList?.map(item => {
        //     return {value: item.vehicleid, label: item.vehicle}
        // })
        return []
    }

    const onSubmit = async (data: FormData) => {
        var body = {
            guid: params.calendarGuid
        }
        if (data?.customernumber) {
            body['customernumber'] = data?.customernumber
        }
        // console.log(body)
        axios.post('/emergency', body)
        closeDialog()
    }
    
    return (
      <div className={styles.root}>
          <>
              <Dialog open={openVacation} onClose={handleClose} aria-labelledby="form-dialog-title">
                  <DialogTitle id="form-dialog-title">Add Vacation</DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          Please enter the vacation details.
                      </DialogContentText>
                      <TextField
                          autoFocus
                          margin="dense"
                          id="startDate"
                          label="Start Date"
                          type="date"
                          fullWidth
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          error={!!errors.startDate}
                          helperText={errors.startDate}
                          InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                          margin="dense"
                          id="endDate"
                          label="End Date"
                          type="date"
                          fullWidth
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          error={!!errors.endDate}
                          helperText={errors.endDate}
                          InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                          margin="dense"
                          id="comment"
                          label="Comment"
                          type="text"
                          fullWidth
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                      />
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={handleClose} color="primary">
                          Cancel
                      </Button>
                      <Button onClick={handleAdd} color="primary">
                          Add
                      </Button>
                  </DialogActions>
              </Dialog>
          </>
          <>
              <Dialog
                  open={dialogMessage.length > 0}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description">
                  <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                          {dialogMessage}
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={closeDialog}>Ok</Button>
                  </DialogActions>
              </Dialog>
          </>
        <>
          <Dialog
            open={dialogMsg.length > 0}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogContent>
                <HookForm
                    methods={formMethods}
                    onSubmit={onSubmit}
                    className={styles.itemsForm}
                    formProps={{ id: 'items-form' }}>
                    <FormControl fullWidth>
                        <TextInput name='customernumber' label='Customer Number'
                                   textFieldProps={{ type: 'number' }}
                        ></TextInput>
                    </FormControl>
                    <FormControl fullWidth>
                        <AutocompleteSelect
                            name="customerid"
                            label="Customer"
                            options={getCustomerOptions()}
                        />
                    </FormControl>
                </HookForm>
              <DialogContentText id="alert-dialog-description">
                {dialogMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={closeDialog}
                >
                    No
                </Button>
                <Button
                    variant="contained"
                    className={styles.submitButton}
                    type="submit"
                    form="items-form">
                    Yes
                </Button>
            </DialogActions>
          </Dialog>
        </>
        {calendarData && calendarData.status === 'failure' ? (
          <Typography
            variant="h6"
            color="primary"
            align="center"
            component="div">
            {calendarData.message}
          </Typography>
        ) : (
          <>
            <>
              <SchedulesForm
                isOpen={isFormShowing}
                setIsOpen={setIsFormShowing}
                gridParams={gridParams}
                scheduleDropdowns={scheduleDropdowns}
                reloadForm={reloadForm}
                isClone={false}
                woid={gridParams?.scheduledivisionwoid}
              />
            </>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {buildLegend()}
                <Calendar
                  components={{ event: Event }}
                  localizer={localizer}
                  events={eventFilteredData}
                  startAccessor="start"
                  endAccessor="end"
                  // defaultDate={new Date()}
                  defaultView="week"
                  views={['month', 'week', 'day']}
                  style={{ 'height': 500 }}
                  // onSelectEvent={event => {
                  //     HandleEventClick(event.scheduleid)
                  // }}
                  onDoubleClickEvent={(event) => {
                    HandleEventClick(event.scheduleid)
                  }}
                  date={selectedDate}
                  onNavigate={(date) => {
                    console.log(date)
                    setSelectedDate(date)
                  }}
                  eventPropGetter={eventStyleGetter}
                />
              </Grid>
            </Grid>
          </>
        )}
      </div>
    )
}
export default CalendarPage
